module.exports = __webpack_public_path__ + "img/130.a3f07eb6.jpg";